var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmptyLayout',{attrs:{"isBgTransparent":_vm.customStyleData.gameSessionBackgroundColor === 'transparent'}},[_c('list-product-index',{attrs:{"isGameSession":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }